import React from 'react';
import sendGaEvent from '@gc-npm/utils.metrics.send-ga-component-event';
import CardSelect from '@/components/Recomendador/CardSelect';
import CustomLink from '@gc-npm/components.custom-link';
import { actions as cartActions } from '@/reducers/cart';
import { CONECTIVIDAD_BASE_ID, BASE_R2R_UPGRADES, VALID_INPUTS_RECOMEND } from '@/utils/constants';

import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
} from '@gc-npm/components.text';
import { isArrayNotEmpty, isEmpty } from '@/utils/validations';
import ProductCard from '@/components/Recomendador/cms-detail-card';

export const getComponentProductForTagging = (selectedItems) => {
  let result = '';

  if (selectedItems) {
    const parts = [];

    if (selectedItems.fiber) {
      parts.push(selectedItems.fiber);
    }

    if (selectedItems.mobileLines) {
      parts.push(selectedItems.mobileLines);
    }

    if (Array.isArray(selectedItems.tvChannels) && selectedItems.tvChannels.length > 0) {
      parts.push(selectedItems.tvChannels.join('-'));
    }

    result = parts.join(';');
  }

  return result;
}

export const getAndSendTaggingInfo = ({ product, selectedItems, name }) => {
  const {
    idCard,
    items,
    recommendation,
  } = product || {};
  let productId = idCard;
  let variation = 'all';
  if (
    !idCard
    && items
    && Array.isArray(items)
    && items.length > 0
  ) {
    productId = items
      .filter((item) => typeof item.id === 'string' && !item.id.startsWith('9940'))
      .map((item) => item.id)
      .join(';');
  }
  if (recommendation && recommendation['cms-atom-price-2'] && recommendation['cms-atom-price-2'].price) {
    variation = 'promoted'
  }
  if (recommendation
      && recommendation['cms-hiring-details-1']
      && recommendation['cms-hiring-details-1']['cms-json-rules-1']
      && isArrayNotEmpty(recommendation['cms-hiring-details-1']['cms-json-rules-1'])
  ) {
    const traductorProducts = recommendation['cms-hiring-details-1']['cms-json-rules-1']
      .filter((item) => String(item.id).startsWith('9940'))
      .flatMap((item) => item.logic?.output ?? [])
      .join(';')
    if (traductorProducts) {
      productId = `${productId};${traductorProducts}`;
    }
  }
  const taggingInfo = {
    componentContent: getComponentProductForTagging(selectedItems),
    componentName: name,
    componentProduct: productId,
    componentVariation: variation,
    eventType: 'print-success',
  }
  sendGaEvent(taggingInfo);
}

export const buildAndRenderProductCard = (
  dispatch,
  product,
  selectedItems,
  onclickMobileLinesModal,
  isLoaded,
) => {
  let productCard = null;

  const {
    items,
    idCard,
    recommendation,
  } = product || {};

  let productId = idCard;

  if (
    !idCard
    && items
    && Array.isArray(items)
    && items.length > 0
  ) {
    productId = items
      .filter((item) => typeof item.id === 'string' && !item.id.startsWith('9940'))
      .map((item) => item.id)
      .join(';');
  }

  if (!isEmpty(recommendation)) {
    const childrenMap = {};
    let variation = 'all';

    if (
      recommendation['cms-atom-price-2']
      && recommendation['cms-atom-price-2'].price
    ) {
      variation = 'promoted'
    }

    if (
      recommendation['cms-hiring-details-1']
      && recommendation['cms-hiring-details-1']['cms-json-rules-1']
      && isArrayNotEmpty(recommendation['cms-hiring-details-1']['cms-json-rules-1'])
    ) {
      const traductorProducts = recommendation['cms-hiring-details-1']['cms-json-rules-1']
        .filter((item) => String(item.id).startsWith('9940'))
        .flatMap((item) => item.logic?.output ?? [])
        .join(';')
      if (traductorProducts) {
        productId = `${productId};${traductorProducts}`;
      }
    }

    if (
      recommendation['cms-hiring-details-1']
      && recommendation['cms-hiring-details-1']['cms-json-rules-2']
      && recommendation['cms-hiring-details-1']['cms-json-rules-2'].showLinesModal
    ) {
      const linesToSelect = recommendation['cms-hiring-details-1']['cms-json-rules-2']?.linesToSelect || null;
      childrenMap['cms-children-1'] = (
        <CustomLink
          onClick={() => onclickMobileLinesModal(linesToSelect)}
          taggingInfo={{
            componentContent: getComponentProductForTagging(selectedItems),
            componentName: 'modal-lineas-moviles-recomendador',
            componentProduct: productId,
            componentVariation: variation,
          }}
        >
          <TextInfo
            text="Añadir una línea móvil extra >"
            color={TEXT_COLOR.MOVISTAR_BLUE}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
            size={TEXT_SIZE.BODY1}
          />
        </CustomLink>
      );
    }

    if (
      recommendation['cms-hiring-details-1']
    ) {
      childrenMap['cms-children-2'] = (
        <CardSelect
          hiringDetails={recommendation['cms-hiring-details-1']}
          oldSelectedItems={selectedItems}
          ariaLabel="Selecciona algo"
          items={items}
          idCard={idCard}
        />
      );
    }

    if (
      recommendation['cms-atom-button-1']
      && !recommendation['cms-atom-button-1'].href
      && !idCard
      && items
      && Array.isArray(items)
      && items.length > 0
    ) {
      const { price } = recommendation['cms-atom-price-1'];
      const onclickButton = () => {
        // a falta de que el purchase pueda recibir
        // elementos por parametros para pasarle los items del bundle
        dispatch(cartActions.purchase({ cartIds: items, price }));
      };
      recommendation['cms-atom-button-1'].href = null;
      recommendation['cms-atom-button-1'].onClick = onclickButton;
      recommendation['cms-atom-button-1'].taggingInfo = {
        componentContent: getComponentProductForTagging(selectedItems),
        componentName: 'button-contratar-recomendador',
        componentProduct: productId,
        componentVariation: variation,
      };
    }

    const detailCardProps = {
      ...recommendation,
      'cms-atom-link-1': {},
      'cms-chidlrens': childrenMap,
      loaded: isLoaded,
    };

    productCard = <ProductCard detailCardProps={detailCardProps} />;
  }

  return productCard;
}
export const checkForCorrectParams = (urlParams) => {
  let correctParams = true;

  const {
    fiber,
    mobileLines,
    tvChannels,
  } = urlParams || {};

  if (fiber && mobileLines) {
    if (
      fiber
      && !VALID_INPUTS_RECOMEND.fiber.includes(fiber)
    ) {
      correctParams = false;
    }

    if (
      mobileLines
      && !VALID_INPUTS_RECOMEND.mobileLines.includes(mobileLines)
    ) {
      correctParams = false;
    }

    if (tvChannels) {
      const modulos = tvChannels.split(';');
      if (!Array.isArray(modulos) || modulos.length === 0) {
        correctParams = false;
      }

      modulos.forEach((modulo) => {
        if (!VALID_INPUTS_RECOMEND.tvChannels.includes(modulo)) {
          correctParams = false;
        }
      });
    }
  } else {
    correctParams = false
  }

  return correctParams;
};

export const getIfBaseInRecommendations = (item) => {
  const items = item?.items;

  if (!Array.isArray(items) || items.length === 0) {
    return false;
  }

  const isBaseSelected = items.some(
    (module) => module?.id?.includes(CONECTIVIDAD_BASE_ID)
  );

  const isFutbolOrFiccionSelected = items.some(
    (module) => BASE_R2R_UPGRADES.includes(module?.id)
  );

  return isBaseSelected && !isFutbolOrFiccionSelected;
};
